<form [formGroup]="form">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <h4>Internal Only Attachment</h4>
    <digital-platform-file-upload
      data-cy="Internal-Only-Attachment-Upload-Btn"
      class="Additional"
      fxFlex="500px"
      formControlName="internalOnlyAttachment"
      (fileDeleted)="onFileDelete($event)"
    ></digital-platform-file-upload>
  </div>
</form>
